<script>
import ListingModel from "@/views/Training/Catalog/Components/ListingModel.vue";

export default {
    components: {ListingModel}

};
</script>

<template>
   <ListingModel root-path="catalogs"/>
</template>
